import { getUserEmailFromCookies } from './getUserDetailsUtil'
import {
  CLOUDINARY_API_KEY,
  CLOUDINARY_NAME,
} from '../../../constants/images/cloudinary'
import { KLAVIYO_PUBLIC_API_KEY } from '../../../constants/index'
import { headers } from './headers'
import cloudinary from 'cloudinary-core'
const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
  api_key: CLOUDINARY_API_KEY,
})

export const trackProceedToCheckoutError = (
  bikeId,
  error,
  year,
  make,
  model,
  city,
  state,
  url,
  photoUrlId,
  dailyPrice,
  ownerName
) => {
  const bikeImgToUse = cl.url(photoUrlId, {
    gravity: 'center',
    height: 600,
    width: 900,
    crop: 'fill',
    format: 'jpg',
    quality: 80,
  })

  const options = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      data: {
        type: 'event',
        attributes: {
          properties: {
            MotorcycleId: bikeId,
            Error: error,
            MotorcycleYear: year,
            MotorcycleMake: make,
            MotorcycleModel: model,
            MotorcycleCity: city,
            MotorcycleState: state,
            MotorcycleUrl: url,
            MotorcyclePhoto: bikeImgToUse,
            DailyRate: dailyPrice,
            OwnerName: ownerName,
          },
          metric: {data: {type: 'metric', attributes: {name: 'Reservation Created & Payment Page Viewed (Checkout Error)'}}},
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: getUserEmailFromCookies() ?? ''
              }
            }
          }
        }
      }
    })
  }

  fetch(`https://a.klaviyo.com/client/events/?company_id=${KLAVIYO_PUBLIC_API_KEY}`, options)
  .then(response => {
    console.log('klaviyo tracking trackProceedToCheckoutError success', response)
  })
  .catch(err => {
    console.log('Failed to track trackProceedToCheckoutError', err)
  })
}

export const trackProceedToCheckoutSuccess = (
  bikeId,
  requestId,
  year,
  make,
  model,
  city,
  state,
  url,
  photoUrlId,
  dailyPrice,
  ownerName
) => {
  const bikeImgToUse = cl.url(photoUrlId, {
    gravity: 'center',
    height: 600,
    width: 900,
    crop: 'fill',
    format: 'jpg',
    quality: 80,
  })

  const options = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      data: {
        type: 'event',
        attributes: {
          properties: {
            MotorcycleId: bikeId,
            RequestId: requestId,
            MotorcycleYear: year,
            MotorcycleMake: make,
            MotorcycleModel: model,
            MotorcycleCity: city,
            MotorcycleState: state,
            MotorcycleUrl: url,
            MotorcyclePhoto: bikeImgToUse,
            DailyRate: dailyPrice,
            OwnerName: ownerName,
          },
          metric: {data: {type: 'metric', attributes: {name: 'Reservation Created & Payment Page Viewed'}}},
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: getUserEmailFromCookies() ?? ''
              }
            }
          }
        }
      }
    })
  }

  fetch(`https://a.klaviyo.com/client/events/?company_id=${KLAVIYO_PUBLIC_API_KEY}`, options)
  .then(response => {
    console.log('klaviyo tracking trackProceedToCheckoutSuccess success', response)
  })
  .catch(err => {
    console.log('Failed to track trackProceedToCheckoutSuccess', err)
  })
}

export const trackPaymentSuccessKlaviyo = (
  reservationId,
  year,
  make,
  model,
  city,
  state,
  url,
  photoUrl,
  ownerName,
  ownerEmail,
  subTotal,
  grandTotal
) => {
  const options = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      data: {
        type: 'event',
        attributes: {
          properties: {
            ReservationId: reservationId,
            MotorcycleYear: year,
            MotorcycleMake: make,
            MotorcycleModel: model,
            City: city,
            state: state,
            MotorcycleUrl: url,
            PhotoUrl: photoUrl,
            BikeOwnerName: ownerName,
            BikeOwnerEmail: ownerEmail,
            SubTotal: subTotal,
            GrandTotal: grandTotal,
          },
          metric: {data: {type: 'metric', attributes: {name: 'Payment SUCCESS (User paid for a trip)'}}},
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: getUserEmailFromCookies() ?? ''
              }
            }
          }
        }
      }
    })
  }

  fetch(`https://a.klaviyo.com/client/events/?company_id=${KLAVIYO_PUBLIC_API_KEY}`, options)
  .then(response => {
    console.log('klaviyo tracking trackPaymentSuccessKlaviyo success', response)
  })
  .catch(err => {
    console.log('Failed to track trackPaymentSuccessKlaviyo', err)
  })
}
